<template>
  <v-card flat class="pa-3 mt-1">
    <v-card-title class="d-flex align-center justify-center py-0">
      <v-img
        :src="require(`@/assets/images/logos/logo.png`)"
        max-width="300px"
        alt="logo"
        contain
        class="me-0"
      ></v-img>
    </v-card-title>
    <v-form class="multi-col-validation">
      <v-card-text class="pt-1">
        <p class="text-h6 text-center">Make a Deposit</p>
        <input type="hidden" v-model="payment_ref" ref="payment_ref" id="payment_ref">
        <v-row>
          <v-col cols="10" class="py-0 my-1">
            <v-text-field
              v-model="userName"
              ref="userName"
              outlined dense
              label="Search username, phone number, unique code..."
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="py-0 my-1">
            <v-btn color="success" class="me-3" fab small @click="getUsers()">
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
            </v-btn>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-select
              v-model="selectedUser"
              ref="selectedUser"
              :items="users"
              item-text="username"
              item-value="id"
              outlined dense
              label="Select a user"
              @change="getUserDetails()"
            ></v-select>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-text-field
              v-model="phoneNumber"
              ref="phoneNumber"
              outlined dense
              label="User Phone Number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-select
              v-model="selectedLoanCampaign"
              ref="selectedLoanCampaign"
              outlined return-object dense
              :items="loans_campaigns"
              item-text="name"
              item-value="id"
              label="Select Loan/Campaign"
            ></v-select>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-text-field
              v-model="amount"
              ref="amount"
              outlined dense
              label="Amount"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-text-field
              v-model="currentPassword"
              ref="currentPassword"
              :type="isCurrentPasswordVisible ? 'text' : 'password'"
              :append-icon="isCurrentPasswordVisible ? mdiEyeOffOutline : mdiEyeOutline"
              label="Input Current Password"
              outlined dense
              @click:append="isCurrentPasswordVisible = !isCurrentPasswordVisible"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-checkbox label="Send SMS to Client containing campaign status, completion rate, deposited amount, date and manager" hide-details class="me-3 mt-1"></v-checkbox>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-checkbox label="Send Email to Client" hide-details class="me-3 mt-1"></v-checkbox>
          </v-col>
          <v-col cols="12" class="py-0 my-1">
            <v-checkbox label="Send Notification to Client" hide-details class="me-3 mt-1"></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="text-end">
        <spinner v-if="loading" class="text-end"></spinner>
        <v-btn v-else color="primary" class="me-3 mt-3" @click="depositMoneyCampaign()">
          Deposit
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import axios from 'axios'
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      loading: false,
      userName: "",
      selectedUser: "",
      phoneNumber: "",
      selectedLoanCampaign: null,
      isCurrentPasswordVisible: false,
      currentPassword: "",
      amount: "",
      payment_ref: "",
      users: [],
      loans_campaigns: [],
      mdiKeyOutline,
      mdiLockOpenOutline,
      mdiEyeOffOutline,
      mdiEyeOutline,
    }
  },

  mounted() {
    this.getDepositPaymentRef();
    document.title = "Manager: Savings | Deposit into Campaign"
  },

  methods: {
    getUsers() {
      axios.get('/api/v1/manager/get/clients/' + this.userName + '/')
        .then(response => {
          this.users = response.data
          console.log(this.users)
        })
        .catch(error => {
          this.handleError(error)
        })
    },

    getUserDetails() {
      axios.get('/api/v1/manager/get/client/information/' + this.selectedUser + '/')
        .then(response => {
          console.log(response.data)
          this.phoneNumber = response.data.phone_number
          // Récupérer toutes les campagnes et filtrer celles de type Marketer ou Items
          const allCampaigns = response.data.user_campaigns || []
          this.loans_campaigns = allCampaigns.filter(
            item => item.type !== 'Marketer' && item.type !== 'Items'
          )
          console.log('Campagnes après filtrage :', this.loans_campaigns)
        })
        .catch(error => {
          this.handleError(error)
        })
    },

    async getDepositPaymentRef() {
      try {
        const response = await axios.get('/api/v1/manager/create/user/deposits/payment_ref/')
        this.payment_ref = response.data
      } catch (error) {
        this.handleError(error)
      }
    },

    async depositMoneyCampaign() {
      // Valider le payment_ref
      if (this.payment_ref === "") {
        this.$store.commit('setSnackBarMessage', "Une erreur est survenue : la référence de paiement est nulle. Veuillez recharger la page.")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        window.location.reload()
        return
      }

      // Valider la sélection de la campagne/loan
      if (!this.selectedLoanCampaign) {
        this.$store.commit('setSnackBarMessage', "Veuillez sélectionner la campagne ou le prêt du client.")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        this.$refs.selectedLoanCampaign.focus()
        return
      }

      // Valider le montant
      if (this.amount === "" || isNaN(Number(this.amount))) {
        const msg = this.amount === "" ? "Veuillez saisir le montant." : "Veuillez saisir uniquement des chiffres pour le montant."
        this.$store.commit('setSnackBarMessage', msg)
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        this.$refs.amount.focus()
        return
      }

      // Valider le mot de passe
      if (this.currentPassword === "") {
        this.$store.commit('setSnackBarMessage', "Veuillez saisir votre mot de passe.")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        return
      }

      // Construction du FormData
      let formData = new FormData()
      if (this.selectedLoanCampaign.name.includes("Loan:")) {
        formData.append('loan', this.selectedLoanCampaign.id)
      } else if (this.selectedLoanCampaign.name.includes("Campaign:")) {
        formData.append('campaign', this.selectedLoanCampaign.id)
      } else {
        // fallback: on essaye de détecter par le type ou on utilise l'id
        // On peut aussi ajouter une logique plus robuste
        this.$store.commit('setSnackBarMessage', "Type de sélection non reconnu.")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        return
      }
      formData.append('payment_ref', this.payment_ref)
      formData.append('amount', this.amount)
      formData.append('password', this.currentPassword)

      // Activation du spinner
      this.loading = true

      try {
        const response = await axios.post('/api/v1/manager/deposits/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        // Succès
        const data = response.data[0]
        this.$store.commit('setSnackBarMessage', data.text)
        this.$store.commit('setSnackBarColor', data.color)
        this.$store.commit('activateSnackBar', true)
        if (data.category === "success") {
          setTimeout(() => {
            this.$router.push('/savings/deposit_transactions')
          }, 4000)
        }
      } catch (error) {
        // Gestion des erreurs
        let message = "Une erreur s'est produite. Veuillez vérifier la console."
        if (error.response) {
          // Le serveur a répondu avec un statut hors 2xx
          message = error.response.status + " " + error.response.statusText
          // Si le serveur renvoie du JSON structuré, on l'utilise
          if (error.response.data && error.response.data[0] && error.response.data[0].text) {
            message = error.response.data[0].text
          }
        } else if (error.request) {
          message = "Aucune réponse du serveur. Vérifiez votre connexion internet."
        }
        this.$store.commit('setSnackBarMessage', message)
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
      } finally {
        this.loading = false
      }
    },

    // Méthode utilitaire pour gérer les erreurs des appels GET
    handleError(error) {
      if (error.response) {
        this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
      } else {
        this.$store.commit('setSnackBarMessage', "Une erreur est survenue, vérifiez votre connexion internet et réessayez.")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
      }
    }
  },
}
</script>
